import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import "react-datepicker/dist/react-datepicker.css";
import store from "./store";
import configDEV from "./config/cognito-dev.json";
import configDEMO from "./config/cognito-demo.json";
import configStage from "./config/cognito-staging.json";
// import configProd from './config/cognito-production.json';
import { setupCognito } from "./react-cognito/index";
import { fetchPetShops, getPetshopByTitle } from "./actions/petShop";

let appConfig = {};
const appEnv = process.env.REACT_APP_ENV;
// const document = typeof document === 'undefined' ? '' : document;
switch (appEnv) {
  case "development":
    appConfig = configDEV;
    break;
  case "staging":
    appConfig = configStage;
    break;
  // case 'production':
  //   appConfig = configProd;
  //   break;
  case "local":
    appConfig = configDEV;
    break;
  default:
    appConfig = configDEMO;
    break;
}

setupCognito(store, appConfig.cognito);

const loadFromUrl = store => {
  let split_1 = window.location.hostname.split(".")[0];
  if (split_1 === "192") split_1 = "localhost";
  var avoid = ["staging", "petpos"];
  if (avoid.indexOf(split_1) < 0) {
    store.dispatch(getPetshopByTitle(split_1));
  }
};

loadFromUrl(store);

// if (typeof window !== 'undefined') {
ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("root")
);
// }
